<nz-skeleton-element
  nzShape="circle"
  nzType="avatar"
  [nzActive]="active"
  [nzSize]="size"></nz-skeleton-element>
<nz-skeleton-element
  nzType="input"
  [nzActive]="active"
  [nzSize]="size"></nz-skeleton-element>
